export default function NotFound() {
  return (
    <div>
      <h2>404 Not Found</h2>
    </div>
  );
}
